import { CUSTOM_ELEMENTS_SCHEMA, Component, OnInit } from '@angular/core';
import { AccountService } from '../../../services/account.service';
import { AuthService } from '../../../services/auth.service';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { Roles, RoleTypes } from '../../../models/enums';
import { Router } from '@angular/router';
import { TeamSelectionViewModel } from '../../../models/team/team.model';
import { Role } from '../../../models/role.model';
import { ODPProjectWorkflowViewModel } from '../../../models/odpprojectworkflow/odpProjectWorkflow.model';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-account-select-active-role',
  templateUrl: './account-select-active-role.component.html',
  styleUrls: ['./account-select-active-role.component.css'],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatRadioModule,
    ReactiveFormsModule
  ]
})
export class AccountSelectActiveRoleComponent implements OnInit {

  //selectionMadeInList1: boolean = false;

  availableRoles: {
    title: string;
    value: Roles
  }[] = [];

  availableProjects: {
    title: string;
    value: ODPProjectWorkflowViewModel
  }[] = [];

  availableTeams: {
    title: string;
    workflowTaskTitle: string;
    value: TeamSelectionViewModel
  }[] = [];

  rolesWData: Role[] = [];
  currentRoleWData: Role;
  loadedRoles: boolean = false;

  showProjects: boolean = false;
  showTeams: boolean = false;
  showSubmit: boolean = false;

  hasProjects: boolean = true;
  hasTeams: boolean = true;

  //currentRoleSelection: Roles = this.accountService.GetActiveRole();
  //currentTeamSelection: TeamSelectionViewModel = this.accountService.GetActiveTeam();

  currentRoleIDSelection: Roles | null = null;
  currentProjectSelection: ODPProjectWorkflowViewModel | null = null;
  currentTeamSelection: TeamSelectionViewModel | null = null;



  constructor(
    private accountService: AccountService,
    private authService: AuthService,
    private alertService: AlertService,
    private router: Router
  ) { }

  roleToTitle(role: Roles): string {
    switch (role) {
      case Roles.Admin:
        return "Admin";
      case Roles.ReconciliationSupervisor:
        return "Reconciliation Supervisor";
      case Roles.ReconciliationCoder:
        return "Reconciliation Coder";
      case Roles.QCSupervisor:
        return "QC Supervisor";
      case Roles.QCCoder:
        return "QC Coder";
      default:
        return null;
    }
  }

  submitTeamAndRoleSelection() {
    this.accountService.SetActiveRole(+this.currentRoleIDSelection);

    if (this.currentProjectSelection) {
      this.accountService.SetActiveProject(this.currentProjectSelection);
    }
    else {
      this.accountService.SetActiveProject(null);
    }

    if (this.currentTeamSelection) {
      this.accountService.SetActiveTeam(this.currentTeamSelection);
    }
    else {
      this.accountService.SetActiveTeam(null);
    }

    var newRole = this.accountService.GetActiveRole();
    var newProject = this.accountService.GetActiveProject();
    var newTeam = this.accountService.GetActiveTeam();

    this.alertService.showMessage("Active Role", `Switched active role to ${this.roleToTitle(newRole)} successfully.`, MessageSeverity.success);

    //if (newProject)
    //  this.alertService.showMessage("Active Project", `Switched active project to ${newProject.projectTitle} successfully.`, MessageSeverity.success);

    if (newTeam)
      this.alertService.showMessage("Active Team", `Switched active team to ${newTeam.teamId}: ${newTeam.teamMembers}`, MessageSeverity.success);

    this.accountService.SetActiveValsSelected(true);
    this.router.navigate(['/home/actions']);
  }

  findMatchingTeam(availableTeamsModels: Array<any>, thisTeam: TeamSelectionViewModel) {
    for (var i = 0; i < availableTeamsModels.length; i++)
      if (availableTeamsModels[i].value.teamId == thisTeam.teamId)
        return availableTeamsModels[i].value;

    return null;
  }

  findMatchingProject(availableProjectModels: Array<any>, thisProject: ODPProjectWorkflowViewModel) {
    for (var i = 0; i < availableProjectModels.length; i++)
      if (availableProjectModels[i].value.teamId == thisProject.odpProjectWorkflowId)
        return availableProjectModels[i].value;

    return null;
  }

  onRoleChange() {
    this.accountService.SetActiveValsSelected(false);
    this.showTeams = false;
    this.showProjects = false
    this.currentProjectSelection = null;
    this.currentTeamSelection = null;
    console.log(`from onRoleChange, currentProjectSelection = ${this.currentProjectSelection} and currentTeamSelection = ${this.currentTeamSelection}`);
    setTimeout(() => {
      this.getProjects(true);     
    });
  }

  onProjectChange() {
    this.showTeams = false;
    this.currentTeamSelection = null;
    console.log(`from onProjectChange, currentProjectSelection = ${this.currentProjectSelection} and currentTeamSelection = ${this.currentTeamSelection}`);
    setTimeout(() => {
      this.getTaskTeams(true);
    });
  }

  onTeamChange() {
    console.log(`from onTeamChange, currentProjectSelection = ${this.currentProjectSelection} and currentTeamSelection = ${this.currentTeamSelection}`);
    setTimeout(() => {
      this.setPageComponentVisibility();
    });
  }

  setPageComponentVisibility() {

    console.log(`From beginning of setPageVisibility(), CurrentRoleIdSelection: ${this.currentRoleIDSelection}`);

    this.currentRoleWData = this.rolesWData.find(r => parseInt(r.id) == this.currentRoleIDSelection);
    console.log(`currentToleWData = ${JSON.stringify(this.currentRoleWData)}`);

    if (this.currentRoleWData != null) {
      //if (this.currentRoleWData.roleTypeId != RoleTypes.Admin) {
        this.showProjects = true;
        this.showSubmit = false;
      /*}
      else {
        this.showSubmit = true;
        this.showProjects = false;
      }*/
    }

    if (this.currentProjectSelection != null) {
      if (this.currentRoleWData.roleTypeId == RoleTypes.Coder) {
        console.log(`currentProjectSelection is ${this.currentProjectSelection}, set teams is about to be set to true.`);
        this.showTeams = true;
        this.showSubmit = false;
      }
      else {
        this.showSubmit = true;
        this.showTeams = false;
      }
    }

    if (this.currentTeamSelection != null) {
      console.log(`currentProjectSelection is ${this.currentTeamSelection}`);
      if (this.currentRoleWData.roleTypeId == RoleTypes.Coder) {
        this.showSubmit = true;
      }
      else {
        this.showSubmit = false;
      }
    }

    console.log(`from end of setPageVisibility(), showProjects is ${this.showProjects}`)
    console.log(`from end of setPageVisibility(), showSubmit is ${this.showSubmit}`)
    console.log(`from end of setPageVisibility(), showTeams is ${this.showTeams}`)
  }


  ngOnInit() {
    //this.accountService.SetActiveValsSelected(false);
    var currentUserRoleIds = this.accountService.GetCurrentUserRoleIDs();

    this.accountService.getRoles().subscribe(rolesResult => {     
      this.rolesWData = rolesResult.filter(r => currentUserRoleIds.includes(parseInt(r.id)));
      this.loadedRoles = true;
    });

    for (var i = 0; i < currentUserRoleIds.length; i++)
      this.availableRoles.push({ title: this.roleToTitle(currentUserRoleIds[i]), value: currentUserRoleIds[i] });

    if (this.accountService.GetActiveRole() != null) {
      this.getProjects();
      if (this.accountService.GetActiveProject() != null) {
        this.getTaskTeams();
      }
    }

  }

  getProjects(reload: boolean = false) {
    var currentUserProjects = this.accountService.GetCurrentUserProjects();
    for (var i = 0; i < currentUserProjects.length; i++)
      this.availableProjects.push({ title: currentUserProjects[i].projectTitle, value: currentUserProjects[i] });
    this.accountService.GetCurrentUserProjectsObservable(this.currentRoleIDSelection).subscribe({
      next: success => {
        currentUserProjects = this.accountService.GetCurrentUserProjects();
        this.availableProjects = [];

        for (var i = 0; i < currentUserProjects.length; i++)
          this.availableProjects.push({ title: currentUserProjects[i].projectTitle, value: currentUserProjects[i] });

        this.hasProjects = !(this.availableProjects == null || this.availableProjects.length == 0);

        // If we only have 1 project then just set it here
        if (this.availableProjects.length === 1) {
          this.currentProjectSelection = this.availableProjects[0].value;
          this.onProjectChange();
        }

        if (reload) {
          this.setPageComponentVisibility();
        }
        else {
          if (this.availableProjects.length > 0 && !this.accountService.GetActiveProject()) {
            this.currentProjectSelection = this.availableProjects[0].value;
          } else
            this.currentProjectSelection = this.findMatchingProject(this.availableProjects, this.accountService.GetActiveProject());
        }
      },
      error: (error) => {
        console.log("Failed to poll current user projects.");
      }
    });
  }

  getTaskTeams(reload: boolean = false) {
    var currentUserTeams = this.accountService.GetCurrentUserTeams();

    console.log("currentUserTeams");
    console.log(currentUserTeams);

    for (var i = 0; i < currentUserTeams.length; i++)
      this.availableTeams.push({
        title: currentUserTeams[i].teamId.toString() + ": " + currentUserTeams[i].teamMembers,
        workflowTaskTitle: currentUserTeams[i].workflowTaskTitle, value: currentUserTeams[i]
      });

    console.log("Current team selection");
    console.log(this.currentTeamSelection);
    if (this.currentRoleWData != null) {
      if (this.currentRoleWData.roleTypeId == RoleTypes.Coder) {
        this.accountService.GetCurrentUserTeamsObservable(this.currentRoleIDSelection, this.currentProjectSelection).subscribe({
        next: success => {
            currentUserTeams = this.accountService.GetCurrentUserTeams();

            this.availableTeams = [];

            for (var i = 0; i < currentUserTeams.length; i++) {
              var abscount = currentUserTeams[i].abstractCount;
              var abscountstring = (abscount != -1) ? " (" + currentUserTeams[i].abstractCount + " abstracts)" : "";
              this.availableTeams.push({
                title: currentUserTeams[i].teamId.toString() + ": " + currentUserTeams[i].teamMembers + abscountstring,
                workflowTaskTitle: currentUserTeams[i].workflowTaskTitle, value: currentUserTeams[i]
              });
            }

            this.hasTeams = !(this.availableTeams == null || this.availableTeams.length == 0);

            // If we only have 1 team then just set it here
            if (this.hasTeams && this.availableTeams.length === 1) {
              this.currentTeamSelection = this.availableTeams[0].value;
              this.onTeamChange();
            }

            if (reload) {
              this.setPageComponentVisibility();
            }
            else {
              if (this.availableTeams.length > 0 && !this.accountService.GetActiveTeam()) {
                this.currentTeamSelection = this.availableTeams[0].value;
              } else
                this.currentTeamSelection = this.findMatchingTeam(this.availableTeams, this.accountService.GetActiveTeam());
            }
          },
        error: (error) => {
            console.log("Failed to poll current user teams.");
          }
      });
      }
      else if (reload) {
        this.setPageComponentVisibility();
      }
    }

  }

}
